import React from 'react';

import {
  CardDocListStyled,
  CardTextStyled,
  H2Truncated,
  CardDocListWrapper,
} from './PageContentCardStyled';
import { Link } from 'theSource/components';
import { CardContentProps } from './types';

export const CardContent = ({
  label,
  content,
  contentRef,
  documents,
}: CardContentProps) => {
  return (
    <React.Fragment>
      {label && (
        <H2Truncated gutterBottom variant="body1Heading" component="h3">
          {label}
        </H2Truncated>
      )}

      {content && (
        <CardTextStyled
          ref={contentRef}
          component="span"
          data-testid="page-content"
        >
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </CardTextStyled>
      )}
      {!content && documents && (
        <CardDocListWrapper ref={contentRef}>
          <CardDocListStyled className="docList">
            {documents.map((document: any, index: number) => (
              <li key={index}>
                <span>
                  <Link
                    path={`${document.document_url}`}
                    value={document.label || 'document'}
                    target="_blank"
                    download
                  />
                </span>
              </li>
            ))}
          </CardDocListStyled>
        </CardDocListWrapper>
      )}
    </React.Fragment>
  );
};
